import {combineReducers} from 'redux';
import auth from './AuthReducer';
import customers from './CustomerReducer';
import apiCallsInProgressCount from './ApiCallsReducer';
import notifications from './NotificationReducer';
import alerts from './AlertsReducer';
import panel from './PanelReducers';
import contracts from './contractsReducer';
import representatives from './representativesReducer';
import user from './userReducer';
import loading from './LoadingReducer';
import notificationMessages from './NotificationMessagesReducer';
import notificationGroups from './NotificationGroupReducer';
import policies from './PoliciesReducer';

export const RESET_STATE = 'RESET_STATE';

const appReducer = combineReducers({
    auth,
    user,
    customers,
    apiCallsInProgressCount,
    notifications,
    alerts,
    panel,
    contracts,
    representatives,
    loading,
    notificationMessages,
    notificationGroups,
    policies
});

/**
 * Resetting Redux State with a Root Reducer
 * https://alligator.io/redux/reset-state-redux/
 */
const rootReducer = (state, action) => {
    if (action.type === RESET_STATE) {
        state = undefined;
    }
    return appReducer(state, action);
};

export default rootReducer;
